<template>
  <div class="trade-head">
    <van-nav-bar :border="false">
        <template #left>
           <span style="font-size: 18px;color:rgb(0, 230, 255);font-weight: 600;">{{ $t('option.typetitle') }}</span>
        </template>
    </van-nav-bar>
    <van-nav-bar :border="false">
        <template #left>
            <van-icon name="bars" size="24px" @click="toType" />
            &nbsp;
            <span style="font-size: 18px;font-weight: 700;">{{ safeName }}</span>
            &nbsp;<span :class="safeNum.indexOf('+') != -1 ? 'data-up' : 'data-down'">{{ safeNum }} %</span>
        </template>
        <template #right>
          <van-icon name="chart-trending-o" size="24" @click="toPage()" />
        </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: "TradeHeader",
  props: ['name','num','title'],
  computed:{
    safeName(){
        return this.name || '...'
    },
    safeNum(){
        return this.num || 'NaN'
    },
    safeTitle(){
      return this.title || ''
    }
  },
  watch: {
    name() {
    },
    num() {
    }
  },
  methods:{
    toType(){
      this.$emit('child-event')
    },
    toPage(){
      this.$router.push(
        {
          name: "options",
          query: {
            currentSymbol: this.safeTitle,
            name:this.safeName,
            moduletype:2
          },
        },
        () => {}
      );
    }
  }
};
</script>

<style>
</style>
